import React from 'react'
import DeliveryTermDetailsContent from '../../../components/Dashboard/DeliveryTermsListContent/View';
import { Link } from 'react-router-dom';

function DeliveryTermDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Delivery Term Details</h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li> <Link to="/delivery-terms">
                  Delivery Terms
                </Link></li>
              <li>Delivery Terms Details</li>
            </ul>
          </div> */}
           
          <DeliveryTermDetailsContent />
        </>
      );
}

export default DeliveryTermDetails
